import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useInsuranceRuntimeData(route: RouteLocationNormalizedLoaded) {
    const locationId = +route.query.locationId
    if (insuranceRuntimeStore.location.id !== locationId) await insuranceRuntimeStore.loadLocation(locationId)
}
